import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Badge } from '@sorare/core/src/atoms/ui/Badge';
import { NotIOsAppFeature } from '@sorare/core/src/components/BuyableFeature';
import { ANY_SPORT_MARKET_WHEEL } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useEnabledWheelByRarity } from '@sorare/core/src/hooks/useEnabledWheelByRarity';

import wheel from '#src/assets/wheel/wheel.svg';
import { useWheelTickets } from '#src/hooks/wheel/useWheelTickets.tsx';

const Wheel = styled.img.attrs({ src: wheel })`
  width: var(--triple-unit);
  height: var(--triple-unit);
`;

export const NavigationSorareWheel = ({ children }: PropsWithChildren) => {
  const enabledWheelByRarity = useEnabledWheelByRarity();
  const { ticketCount, canClaimTicket } = useWheelTickets();
  const { generateSportContextPath } = useSportContext();
  const invisible = ticketCount === 0 && !canClaimTicket;
  const variant = (canClaimTicket && ticketCount === 0 && 'dot') || undefined;
  const badgeContent = ticketCount !== 0 && ticketCount;

  if (!enabledWheelByRarity.limited && !enabledWheelByRarity.common) {
    return null;
  }

  return (
    <NotIOsAppFeature>
      <ButtonBase to={generateSportContextPath(ANY_SPORT_MARKET_WHEEL)}>
        <Horizontal>
          <Badge
            badgeContent={badgeContent}
            variant={variant}
            overlap="circular"
            color="red"
            size="medium"
            invisible={invisible}
          >
            <IconButton size="small" color="transparent" asSpan>
              <Wheel />
            </IconButton>
          </Badge>
          {children}
        </Horizontal>
      </ButtonBase>
    </NotIOsAppFeature>
  );
};
